module.exports = __webpack_public_path__ + "img/lnb_bookmark.4ddfee1e.png";